<template>
  <Teleport to=".rhg-menu-secondary__button">
    <div class="tailwind" style="display: flex; align-items: center; height: 100%">
      <button v-if="isExpanded" class="menu-collapse-button" @click="onCollapse">
        <FontIcon name="arrow-up" />
      </button>
      <Button v-else small @click="onExpand">{{ useTranslate('sbrBook') }}</Button>
    </div>
  </Teleport>
  <Teleport :to="teleportTo">
    <div class="tailwind" style="width: 100%">
      <PropertySearchbar :config="config" />
    </div>
  </Teleport>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import {
  PropertySearchbar,
  Button,
  useTranslate,
  FontIcon,
  useScreen
} from '@common/lib-vue-common'

defineProps({
  config: Object
})

const teleportTo = ref('#searchbar')

const { isXs, isSm } = useScreen('xs', 'sm', 'md', 'lg', 'xl', '2xl')
const isMobile = computed(() => isXs.value || isSm.value)
const isExpanded = ref(false)

const onExpand = () => {
  const sb = document.querySelector('#searchbar-inside-menu')
  if (!sb) return
  teleportTo.value = '#searchbar-inside-menu'
  sb.style.display = 'block'
  isExpanded.value = true
}

const onCollapse = () => {
  const sb = document.querySelector('#searchbar-inside-menu')
  if (!sb) return
  teleportTo.value = '#searchbar'
  sb.style.display = 'none'
  isExpanded.value = false
}

const placeSb = () => {
  //const menu = document.querySelector('.rhg-menu-secondary');
  const searchbar = document.querySelector('#searchbar')
  const button = document.querySelector('.rhg-menu-secondary__button')

  //const menuRect = !!menu ? menu.getBoundingClientRect() : null;
  const searchbarRect = !!searchbar ? searchbar.getBoundingClientRect() : null
  const searchbarIsOverTop =
    searchbarRect && searchbarRect?.y <= -(searchbarRect?.height /*- menuRect?.height*/)

  if (isMobile.value) {
    if (teleportTo.value !== '#searchbar') {
      teleportTo.value = '#searchbar'
    }

    button.style.display = 'none'
  } else {
    if (!searchbarIsOverTop && teleportTo.value !== '#searchbar') {
      teleportTo.value = '#searchbar'
      onCollapse()
    } else if (isExpanded.value) {
      button.style.display = 'flex'
    } else {
      button.style.display = searchbarIsOverTop ? 'flex' : 'none'
    }
  }
}

onMounted(async () => {
  console.log('*** MenuDynamicButton')
  // const menu = document.querySelector('.rhg-menu-secondary');
  const button = document.querySelector('.rhg-menu-secondary__button')

  // if (menu) {
  //   menu.classList.add('rhg-menu-secondary--sticky');
  // }

  if (button) {
    placeSb()
    window?.addEventListener('scroll', placeSb)
    window?.addEventListener('resize', placeSb)
  }
})
</script>

<style lang="css" scoped>
.menu-collapse-button {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  border: solid 2px white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
</style>
